<script>
	let name = 'FYRING';
	let view = 0;
	import { language } from './stores.js';
	import { isMobile } from './stores.js';
	import { isAge } from './stores.js';
	language.set(0);
	isMobile.set(false); //initiate as false
	isAge.set(true)


	import Home from './Home.svelte';
	import Snaps from './Snaps.svelte';
	import MobileMenu from './Mobilemenu.svelte';
	import DesktopMenu from './Desktopmenu.svelte';
	import Kontakt from './Kontakt.svelte';
	import Stig from './Stig.svelte';



	isMobile.set(false); //initiate as false
	// device detection
	if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
    isMobile.set(true);
		console.log("is mobile!")
}

function yes(){
	isAge.set(false);
	console.log("test");
}
function no(){
	window.open("https://www.systembolaget.se/under-20/");
}
</script>


<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Vollkorn">
<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Abril+Fatface">
<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Abril+Fatface">

<!-- HERE VIEW STARTS -->

{#if $isAge}
<div id="wrapper" style="position: absolute;
  left: 0px;
  right: 0px;
  top: 0px; height:100%; background-image: url('https://images.pexels.com/photos/3010340/pexels-photo-3010340.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500');filter: blur(2px);z-index: -1;background-size:120vw auto;">

</div>
<div style="width: 50%; text-align:center; margin:30% auto; ">
<p style="font-size: 16px; text-align: center">
Fyring.se innehåller information om alkohol och riktar sig till dig som är över 20 år. Har du fyllt 20 år?
</p>
<button class="button-31" style="width: 100px; text-align:center; margin:3%;" on:click={yes}>
Ja
</button>

<button class="button-31" style="width: 100px; text-align:center; margin:3%;" on:click={no}>
Nej
</button>

</div>




{:else}


{#if $isMobile}

<MobileMenu bind:view={view}/>



{:else}

<DesktopMenu bind:view={view}/>

{/if}



{#if view == 0}
<Home/>
{:else if view == 1}
<p>
	<Snaps/>
</p>
{:else if view == 2}
<p>
	<Kontakt/>
</p>
{:else if view == 3}

	<Stig/>
{/if}
{/if}
<style>
	:global(body) {
				font-family: Vollkorn;
        background: #F4F2EF;
        color: #3F3D3A;
        transition: background-color 0.3s
    }

		@font-face{
			font-family: 'Flightcase Regular';
			src: url('../fonts/FR.otf') format('otf');
		}
		@font-face{
			font-family: 'FlightcaseTwo';
			src: url('../fonts/FlightcaseRegular.ttf') format('ttf');
		}
		/* CSS */
		.button-31 {
		  background-color: #222;
		  border-radius: 4px;
		  border-style: none;
		  box-sizing: border-box;
		  color: #fff;
		  cursor: pointer;
		  display: inline-block;
		  font-family: "Vollkorn","Helvetica Neue",Arial,sans-serif;
		  font-size: 16px;
		  font-weight: 700;
		  line-height: 1.5;
		  margin: 0;
		  max-width: none;
		  min-height: 44px;
		  min-width: 10px;
		  outline: none;
		  overflow: hidden;
		  padding: 9px 20px 8px;
		  position: relative;
		  text-align: center;
		  text-transform: none;
		  user-select: none;
		  -webkit-user-select: none;
		  touch-action: manipulation;
		  width: 100%;
		}

		.button-31:hover,
		.button-31:focus {
		  opacity: .75;
		}
		p{
			text-align: left;
			font-size: 13px;
		}
		a{
			text-align: left;
			font-size: 13px;
		}
</style>
